/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//  This file was automatically generated and should not be edited.

export type RestaurantFromUrl = {
  __typename: "RestaurantFromUrl";
  id: string;
  name: string;
  platform: string;
};

export type CheckoutSession = {
  __typename: "CheckoutSession";
  clientSecret: string;
};

export type SubscriptionPreview = {
  __typename: "SubscriptionPreview";
  amountDue: number;
  total: number;
  totalExcludingTax: number;
  endingBalance: number;
  periodStart: string;
  periodEnd: string;
};

export type FavoriteList = {
  __typename: "FavoriteList";
  id: string;
  name: string;
  restaurantCount: number;
};

export type Grid = {
  __typename: "Grid";
  id: string;
  name: string;
  columns: Array<string | null>;
  restaurantCount: number;
  emails?: Array<string | null> | null;
  frequency?: ExportFrequency | null;
};

export enum ExportFrequency {
  ONE_WEEK = "ONE_WEEK",
  ONE_MONTH = "ONE_MONTH",
}

export type Export = {
  __typename: "Export";
  username: string;
  url: string;
};

export type QueryFilter = {
  field: QueryFilterField;
  condition: QueryFilterCondition;
  textValue?: string | null;
  intRangeValue?: IntRangeInput | null;
  floatRangeValue?: FloatRangeInput | null;
  locationValue?: LocationInput | null;
};

export enum QueryFilterField {
  GENERAL_TEXT = "GENERAL_TEXT",
  NAME = "NAME",
  CITY = "CITY",
  COUNTRY = "COUNTRY",
  PLATFORM = "PLATFORM",
  PHONE = "PHONE",
  EMAIL = "EMAIL",
  CATEGORY = "CATEGORY",
  RATING = "RATING",
  RATING_COUNT = "RATING_COUNT",
  PROMOTION_COUNT = "PROMOTION_COUNT",
  BUY_X_GET_Y_FREE_PROMOTION_COUNT = "BUY_X_GET_Y_FREE_PROMOTION_COUNT",
  ITEM_PERCENT_OFF_PROMOTION_COUNT = "ITEM_PERCENT_OFF_PROMOTION_COUNT",
  MENU_PERCENT_OFF_PROMOTION_COUNT = "MENU_PERCENT_OFF_PROMOTION_COUNT",
  FREE_DELIVERY_PROMOTION_COUNT = "FREE_DELIVERY_PROMOTION_COUNT",
  FREE_ITEM_PROMOTION_COUNT = "FREE_ITEM_PROMOTION_COUNT",
  ORDER_COUNT = "ORDER_COUNT",
  VIEW_COUNT = "VIEW_COUNT",
  TOP_LEFT_GPS = "TOP_LEFT_GPS",
  BOTTOM_RIGHT_GPS = "BOTTOM_RIGHT_GPS",
  FIRST_SEEN_AT = "FIRST_SEEN_AT",
  FULFILLMENT_TYPE = "FULFILLMENT_TYPE",
  DELIVERY_TIME = "DELIVERY_TIME",
  CREATED_AT = "CREATED_AT",
}

export enum QueryFilterCondition {
  EQUALS = "EQUALS",
  DOES_NOT_EQUAL = "DOES_NOT_EQUAL",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  EXISTS = "EXISTS",
  DOES_NOT_EXIST = "DOES_NOT_EXIST",
  INCLUDES = "INCLUDES",
  DOES_NOT_INCLUDE = "DOES_NOT_INCLUDE",
  STARTS_WITH = "STARTS_WITH",
  DOES_NOT_START_WITH = "DOES_NOT_START_WITH",
  ENDS_WITH = "ENDS_WITH",
  DOES_NOT_END_WITH = "DOES_NOT_END_WITH",
}

export type IntRangeInput = {
  min?: number | null;
  max?: number | null;
};

export type FloatRangeInput = {
  min?: number | null;
  max?: number | null;
};

export type LocationInput = {
  latitude: number;
  longitude: number;
};

export type QuerySort = {
  field: QuerySortField;
  direction: QuerySortDirection;
};

export enum QuerySortField {
  DELIVERY_TIME = "DELIVERY_TIME",
  RATING = "RATING",
  KRUNSH_SCORE = "KRUNSH_SCORE",
  FIRST_SEEN_AT = "FIRST_SEEN_AT",
}

export enum QuerySortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export type QueryResult = {
  __typename: "QueryResult";
  total: number;
  data: Array<Restaurant | null>;
};

export type Restaurant = {
  __typename: "Restaurant";
  id: string;
  platform: string;
  name: string;
  url?: string | null;
  imageUrl?: string | null;
  position: Coordinate;
  rating?: string | null;
  address?: string | null;
  krunshScore: number;
  categories?: Array<string | null> | null;
  firstSeenAt?: string | null;
  lastRefreshedAt?: string | null;
  currencyCode: string;
  currencySymbol: string;
  promotionCount: number;
  deliveryTime: number;
};

export type Coordinate = {
  __typename: "Coordinate";
  latitude: number;
  longitude: number;
};

export type MapPinsResult = {
  __typename: "MapPinsResult";
  total: number;
  data: Array<MapPin | null>;
};

export type MapPin = {
  __typename: "MapPin";
  id: string;
  name: string;
  imageUrl?: string | null;
  address?: string | null;
  position: Coordinate;
  platform: string;
  rating?: string | null;
  deliveryTime?: number | null;
  krunshScore: number;
};

export enum NearbyRadius {
  TWO_HUNDRED_METERS = "TWO_HUNDRED_METERS",
  FIVE_HUNDRED_METERS = "FIVE_HUNDRED_METERS",
  ONE_KILOMETER = "ONE_KILOMETER",
  TWO_KILOMETERS = "TWO_KILOMETERS",
}

export type RestaurantDetails = {
  __typename: "RestaurantDetails";
  id: string;
  platform: string;
  name: string;
  phone?: string | null;
  email?: string | null;
  url?: string | null;
  imageUrl?: string | null;
  position: Coordinate;
  rating?: string | null;
  ratingCount?: string | null;
  fulfillmentTypes?: Array<string | null> | null;
  address?: string | null;
  krunshScore: number;
  krunshScoreDetails: KrunshScoreDetails;
  nearbyIndex: number;
  nearbyRestaurants: NearbyRestaurantsList;
  categories?: Array<string | null> | null;
  firstSeenAt?: string | null;
  lastRefreshedAt?: string | null;
  hasPromotion?: boolean | null;
  openingHours: Array<RestaurantOpeningHours | null>;
  menuItems: Array<MenuItem | null>;
  deliveryTime: number;
  promotionCount: number;
  currencyCode: string;
  currencySymbol: string;
  promotions: Array<RestaurantPromotion | null>;
};

export type KrunshScoreDetails = {
  __typename: "KrunshScoreDetails";
  ratingCount: KrunshSubScore;
  productImages: KrunshSubScore;
  rating: KrunshSubScore;
  deliveryTime: KrunshSubScore;
  productAvailability: KrunshSubScore;
};

export type KrunshSubScore = {
  __typename: "KrunshSubScore";
  value: number;
  badge: string;
  text: Array<KrunshScoreTextBlock | null>;
};

export type KrunshScoreTextBlock = {
  __typename: "KrunshScoreTextBlock";
  type: KrunshScoreTextBlockType;
  title: string;
  items: Array<string | null>;
};

export enum KrunshScoreTextBlockType {
  TEXT = "TEXT",
  UL = "UL",
}

export type NearbyRestaurantsList = {
  __typename: "NearbyRestaurantsList";
  averageRating: number;
  averageScore: number;
  averageDeliveryTime: number;
  restaurants: Array<RestaurantLeaderboardEntry | null>;
};

export type RestaurantLeaderboardEntry = {
  __typename: "RestaurantLeaderboardEntry";
  index: number;
  id: string;
  name: string;
  address?: string | null;
  rating?: string | null;
  deliveryTime: number;
  platform: string;
  position: Coordinate;
  imageUrl?: string | null;
  categories: Array<string | null>;
  krunshScore: number;
  promotionCount: number;
  currencyCode: string;
  currencySymbol: string;
  distance: number;
};

export type RestaurantOpeningHours = {
  __typename: "RestaurantOpeningHours";
  day: Day;
  startTime: string;
  endTime: string;
  menuName: string;
};

export enum Day {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export type MenuItem = {
  __typename: "MenuItem";
  id: string;
  name: string;
  price: number;
  description?: string | null;
  categoryName?: string | null;
  imageUrl?: string | null;
  isSoldOut?: boolean | null;
};

export type RestaurantPromotion = {
  __typename: "RestaurantPromotion";
  type: RestaurantPromotionType;
  minValue?: number | null;
  itemId?: string | null;
  buyCount?: number | null;
  freeCount?: number | null;
  discount?: number | null;
  maxDiscount?: number | null;
};

export enum RestaurantPromotionType {
  BuyXGetYFree = "BuyXGetYFree",
  ItemPercentOff = "ItemPercentOff",
  MenuPercentOff = "MenuPercentOff",
  FreeDelivery = "FreeDelivery",
  FreeItem = "FreeItem",
}

export type RestaurantOverview = {
  __typename: "RestaurantOverview";
  id: string;
  platform: string;
  name: string;
  imageUrl?: string | null;
  address?: string | null;
  krunshScore: number;
  nearbyIndex: number;
  nearbyRestaurants: NearbyRestaurantsList;
};

export type AutocompleteResult = {
  __typename: "AutocompleteResult";
  type: AutocompleteResultType;
  value: string;
  id?: string | null;
};

export enum AutocompleteResultType {
  RESTAURANT = "RESTAURANT",
  CITY = "CITY",
  CATEGORY = "CATEGORY",
  COUNTRY = "COUNTRY",
}

export type RestaurantAutocompleteResult = {
  __typename: "RestaurantAutocompleteResult";
  name: string;
  imageUrl?: string | null;
  address: string;
  id: string;
  platform: string;
  krunshScore: number;
  rating: string;
  deliveryTime: number;
};

export type SearchHistoryItem = {
  __typename: "SearchHistoryItem";
  date: string;
  term: string;
};

export enum HistoryLength {
  SEVEN_DAYS = "SEVEN_DAYS",
  FOURTEEN_DAYS = "FOURTEEN_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
}

export type HistoryData = {
  __typename: "HistoryData";
  krunshScore: Array<HistoryEntry | null>;
  rating: Array<HistoryEntry | null>;
  numberOfRatings: Array<HistoryEntry | null>;
  deliveryTime: Array<HistoryEntry | null>;
  ranking: Array<HistoryEntry | null>;
};

export type HistoryEntry = {
  __typename: "HistoryEntry";
  date: string;
  value: number;
};

export type StripeSubscription = {
  __typename: "StripeSubscription";
  productId: string;
  priceId: string;
  currentPeriodStart: string;
  currentPeriodEnd: string;
  cancelAtPeriodEnd: boolean;
};

export type Entitlement = {
  __typename: "Entitlement";
  name: string;
  count: number;
};

export type StripeProduct = {
  __typename: "StripeProduct";
  name: string;
  description: string;
  marketingFeatures: Array<string | null>;
  prices: Array<StripePrice | null>;
  defaultPrice?: string | null;
  isRecurring: boolean;
  isCreditPack: boolean;
  creditPackInfo?: CreditPackInfo | null;
  isMainSubscription: boolean;
};

export type StripePrice = {
  __typename: "StripePrice";
  id: string;
  lookupKey?: string | null;
  price?: number | null;
  currency: string;
  interval?: string | null;
  taxBehavior?: string | null;
};

export type CreditPackInfo = {
  __typename: "CreditPackInfo";
  count: number;
  popular: boolean;
};

export type StripeInvoicesList = {
  __typename: "StripeInvoicesList";
  invoices: Array<StripeInvoice | null>;
  hasMore?: boolean | null;
};

export type StripeInvoice = {
  __typename: "StripeInvoice";
  id: string;
  amount: number;
  createdAt: string;
  status: InvoiceStatus;
  invoiceUrl?: string | null;
  invoicePdfUrl?: string | null;
};

export enum InvoiceStatus {
  OPEN = "OPEN",
  PAID = "PAID",
  UNCOLLECTIBLE = "UNCOLLECTIBLE",
  VOID = "VOID",
}

export type Notification =
  | KrunshScoreNotification
  | NewRestaurantsNotification
  | RatingNotification
  | NumberOfRatingsNotification
  | RankingNotification
  | NearbyPromotionCountNotification
  | NearbyAveragePriceNotification;

export type KrunshScoreNotification = {
  __typename: "KrunshScoreNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  oldScore: number;
  newScore: number;
};

export enum NotificationType {
  KRUNSH_SCORE = "KRUNSH_SCORE",
  NEW_RESTAURANTS = "NEW_RESTAURANTS",
  RATING = "RATING",
  NUMBER_OF_RATINGS = "NUMBER_OF_RATINGS",
  RANKING = "RANKING",
  NEARBY_PROMOTION_COUNT = "NEARBY_PROMOTION_COUNT",
  NEARBY_AVERAGE_PRICE = "NEARBY_AVERAGE_PRICE",
}

export type NewRestaurantsNotification = {
  __typename: "NewRestaurantsNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  newRestaurantIds: Array<string | null>;
};

export type RatingNotification = {
  __typename: "RatingNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  oldRating: number;
  newRating: number;
};

export type NumberOfRatingsNotification = {
  __typename: "NumberOfRatingsNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  oldNumberOfRatings: number;
  newNumberOfRatings: number;
};

export type RankingNotification = {
  __typename: "RankingNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  oldRanking: number;
  oldRanking7D?: number | null;
  oldRanking28D?: number | null;
  newRanking: number;
  totalCount: number;
};

export type NearbyPromotionCountNotification = {
  __typename: "NearbyPromotionCountNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  oldNearbyPromotionCount: number;
  newNearbyPromotionCount: number;
  restaurantIds: Array<string | null>;
};

export type NearbyAveragePriceNotification = {
  __typename: "NearbyAveragePriceNotification";
  id: string;
  restaurantId: string;
  type: NotificationType;
  isRead: boolean;
  createdAt: string;
  oldNearbyAveragePrice: number;
  newNearbyAveragePrice: number;
};

export type RestaurantsList = {
  __typename: "RestaurantsList";
  total: number;
  data: Array<RestaurantDetails | null>;
};

export type AddUserRestaurantMutationVariables = {
  restaurantId: string;
};

export type AddUserRestaurantMutation = {
  addUserRestaurant: boolean;
};

export type AddUserRestaurantsMutationVariables = {
  restaurantIds: Array<string | null>;
};

export type AddUserRestaurantsMutation = {
  addUserRestaurants: boolean;
};

export type FindRestaurantFromUrlMutationVariables = {
  url: string;
};

export type FindRestaurantFromUrlMutation = {
  findRestaurantFromUrl: {
    __typename: "RestaurantFromUrl";
    id: string;
    name: string;
    platform: string;
  };
};

export type RemoveUserRestaurantMutationVariables = {
  restaurantId: string;
};

export type RemoveUserRestaurantMutation = {
  removeUserRestaurant: boolean;
};

export type SubmitOnboardingMutationVariables = {
  job: string;
  numberOfLocations: string;
  businessObjectives: Array<string | null>;
};

export type SubmitOnboardingMutation = {
  submitOnboarding: boolean;
};

export type SkipOnboardingMutationVariables = {};

export type SkipOnboardingMutation = {
  skipOnboarding: boolean;
};

export type CreateCheckoutSessionMutationVariables = {
  priceId: string;
  quantity?: number | null;
  setup?: boolean | null;
  isLocalhost?: boolean | null;
};

export type CreateCheckoutSessionMutation = {
  createCheckoutSession: {
    __typename: "CheckoutSession";
    clientSecret: string;
  };
};

export type UpdateSubscriptionPriceMutationVariables = {
  priceId: string;
  quantity?: number | null;
};

export type UpdateSubscriptionPriceMutation = {
  updateSubscriptionPrice: boolean;
};

export type PreviewSubscriptionPriceMutationVariables = {
  priceId: string;
  quantity?: number | null;
};

export type PreviewSubscriptionPriceMutation = {
  previewSubscriptionPrice: {
    __typename: "SubscriptionPreview";
    amountDue: number;
    total: number;
    totalExcludingTax: number;
    endingBalance: number;
    periodStart: string;
    periodEnd: string;
  };
};

export type UnsubscribeMutationVariables = {};

export type UnsubscribeMutation = {
  unsubscribe: boolean;
};

export type CreateFavoriteListMutationVariables = {
  name: string;
};

export type CreateFavoriteListMutation = {
  createFavoriteList: {
    __typename: "FavoriteList";
    id: string;
    name: string;
    restaurantCount: number;
  };
};

export type DeleteFavoriteListMutationVariables = {
  favoriteListId: string;
};

export type DeleteFavoriteListMutation = {
  deleteFavoriteList: boolean;
};

export type AddRestaurantsToFavoriteListMutationVariables = {
  favoriteListId: string;
  restaurantIds: Array<string | null>;
};

export type AddRestaurantsToFavoriteListMutation = {
  addRestaurantsToFavoriteList: boolean;
};

export type RemoveRestaurantFromFavoriteListMutationVariables = {
  favoriteListId: string;
  restaurantId: string;
};

export type RemoveRestaurantFromFavoriteListMutation = {
  removeRestaurantFromFavoriteList: boolean;
};

export type UpdateFavoriteListMutationVariables = {
  favoriteListId: string;
  name: string;
};

export type UpdateFavoriteListMutation = {
  updateFavoriteList: {
    __typename: "FavoriteList";
    id: string;
    name: string;
    restaurantCount: number;
  };
};

export type MarkNotificationAsReadMutationVariables = {
  notificationId: string;
};

export type MarkNotificationAsReadMutation = {
  markNotificationAsRead: boolean;
};

export type RefreshRestaurantsMutationVariables = {
  restaurantIds: Array<string | null>;
};

export type RefreshRestaurantsMutation = {
  refreshRestaurants: boolean;
};

export type CreateGridMutationVariables = {
  name: string;
  restaurantIds: Array<string | null>;
  columns: Array<string | null>;
};

export type CreateGridMutation = {
  createGrid: {
    __typename: "Grid";
    id: string;
    name: string;
    columns: Array<string | null>;
    restaurantCount: number;
    emails?: Array<string | null> | null;
    frequency?: ExportFrequency | null;
  };
};

export type UpdateGridMutationVariables = {
  gridId: string;
  name: string;
  restaurantIds: Array<string | null>;
  columns: Array<string | null>;
  emails?: Array<string | null> | null;
  frequency?: ExportFrequency | null;
};

export type UpdateGridMutation = {
  updateGrid: {
    __typename: "Grid";
    id: string;
    name: string;
    columns: Array<string | null>;
    restaurantCount: number;
    emails?: Array<string | null> | null;
    frequency?: ExportFrequency | null;
  };
};

export type DeleteGridMutationVariables = {
  gridId: string;
};

export type DeleteGridMutation = {
  deleteGrid: boolean;
};

export type CreateExportMutationVariables = {
  gridId: string;
};

export type CreateExportMutation = {
  createExport: boolean;
};

export type NewExportMutationVariables = {
  username: string;
  url: string;
};

export type NewExportMutation = {
  newExport: {
    __typename: "Export";
    username: string;
    url: string;
  };
};

export type QueryQueryVariables = {
  filters: Array<QueryFilter | null>;
  offset?: number | null;
  sort?: QuerySort | null;
};

export type QueryQuery = {
  query: {
    __typename: "QueryResult";
    total: number;
    data: Array<{
      __typename: "Restaurant";
      id: string;
      platform: string;
      name: string;
      url?: string | null;
      imageUrl?: string | null;
      rating?: string | null;
      address?: string | null;
      krunshScore: number;
      categories?: Array<string | null> | null;
      firstSeenAt?: string | null;
      lastRefreshedAt?: string | null;
      currencyCode: string;
      currencySymbol: string;
      promotionCount: number;
      deliveryTime: number;
    } | null>;
  };
};

export type GetMapPinsQueryVariables = {
  filters: Array<QueryFilter | null>;
  offset?: number | null;
};

export type GetMapPinsQuery = {
  getMapPins: {
    __typename: "MapPinsResult";
    total: number;
    data: Array<{
      __typename: "MapPin";
      id: string;
      name: string;
      imageUrl?: string | null;
      address?: string | null;
      platform: string;
      rating?: string | null;
      deliveryTime?: number | null;
      krunshScore: number;
    } | null>;
  };
};

export type GetRestaurantDetailsQueryVariables = {
  id: string;
  nearbyRadius?: NearbyRadius | null;
  nearbyTagsInCommon?: number | null;
  tagsExactMatch?: Array<string | null> | null;
};

export type GetRestaurantDetailsQuery = {
  getRestaurantDetails: {
    __typename: "RestaurantDetails";
    id: string;
    platform: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    url?: string | null;
    imageUrl?: string | null;
    position: {
      __typename: "Coordinate";
      latitude: number;
      longitude: number;
    };
    rating?: string | null;
    ratingCount?: string | null;
    fulfillmentTypes?: Array<string | null> | null;
    address?: string | null;
    krunshScore: number;
    krunshScoreDetails: {
      __typename: "KrunshScoreDetails";
    };
    nearbyIndex: number;
    nearbyRestaurants: {
      __typename: "NearbyRestaurantsList";
      averageRating: number;
      averageScore: number;
      averageDeliveryTime: number;
    };
    categories?: Array<string | null> | null;
    firstSeenAt?: string | null;
    lastRefreshedAt?: string | null;
    hasPromotion?: boolean | null;
    openingHours: Array<{
      __typename: "RestaurantOpeningHours";
      day: Day;
      startTime: string;
      endTime: string;
      menuName: string;
    } | null>;
    menuItems: Array<{
      __typename: "MenuItem";
      id: string;
      name: string;
      price: number;
      description?: string | null;
      categoryName?: string | null;
      imageUrl?: string | null;
      isSoldOut?: boolean | null;
    } | null>;
    deliveryTime: number;
    promotionCount: number;
    currencyCode: string;
    currencySymbol: string;
    promotions: Array<{
      __typename: "RestaurantPromotion";
      type: RestaurantPromotionType;
      minValue?: number | null;
      itemId?: string | null;
      buyCount?: number | null;
      freeCount?: number | null;
      discount?: number | null;
      maxDiscount?: number | null;
    } | null>;
  };
};

export type GetRestaurantOverviewQueryVariables = {
  id: string;
};

export type GetRestaurantOverviewQuery = {
  getRestaurantOverview: {
    __typename: "RestaurantOverview";
    id: string;
    platform: string;
    name: string;
    imageUrl?: string | null;
    address?: string | null;
    krunshScore: number;
    nearbyIndex: number;
    nearbyRestaurants: {
      __typename: "NearbyRestaurantsList";
      averageRating: number;
      averageScore: number;
      averageDeliveryTime: number;
    };
  };
};

export type AutocompleteQueryVariables = {
  value: string;
};

export type AutocompleteQuery = {
  autocomplete: Array<{
    __typename: "AutocompleteResult";
    type: AutocompleteResultType;
    value: string;
    id?: string | null;
  } | null>;
};

export type AutocompleteCategoryQueryVariables = {
  value: string;
};

export type AutocompleteCategoryQuery = {
  autocompleteCategory: Array<{
    __typename: "AutocompleteResult";
    type: AutocompleteResultType;
    value: string;
    id?: string | null;
  } | null>;
};

export type AutocompleteCityQueryVariables = {
  value: string;
};

export type AutocompleteCityQuery = {
  autocompleteCity: Array<{
    __typename: "AutocompleteResult";
    type: AutocompleteResultType;
    value: string;
    id?: string | null;
  } | null>;
};

export type AutocompleteCountryQueryVariables = {
  value: string;
};

export type AutocompleteCountryQuery = {
  autocompleteCountry: Array<{
    __typename: "AutocompleteResult";
    type: AutocompleteResultType;
    value: string;
    id?: string | null;
  } | null>;
};

export type AutocompleteRestaurantQueryVariables = {
  value: string;
};

export type AutocompleteRestaurantQuery = {
  autocompleteRestaurant: Array<{
    __typename: "RestaurantAutocompleteResult";
    name: string;
    imageUrl?: string | null;
    address: string;
    id: string;
    platform: string;
    krunshScore: number;
    rating: string;
    deliveryTime: number;
  } | null>;
};

export type GetSearchHistoryQueryVariables = {};

export type GetSearchHistoryQuery = {
  getSearchHistory: Array<{
    __typename: "SearchHistoryItem";
    date: string;
    term: string;
  } | null>;
};

export type GetRestaurantHistoryQueryVariables = {};

export type GetRestaurantHistoryQuery = {
  getRestaurantHistory: Array<{
    __typename: "Restaurant";
    id: string;
    platform: string;
    name: string;
    url?: string | null;
    imageUrl?: string | null;
    position: {
      __typename: "Coordinate";
      latitude: number;
      longitude: number;
    };
    rating?: string | null;
    address?: string | null;
    krunshScore: number;
    categories?: Array<string | null> | null;
    firstSeenAt?: string | null;
    lastRefreshedAt?: string | null;
    currencyCode: string;
    currencySymbol: string;
    promotionCount: number;
    deliveryTime: number;
  } | null>;
};

export type GetUserRestaurantsQueryVariables = {};

export type GetUserRestaurantsQuery = {
  getUserRestaurants: Array<{
    __typename: "Restaurant";
    id: string;
    platform: string;
    name: string;
    url?: string | null;
    imageUrl?: string | null;
    position: {
      __typename: "Coordinate";
      latitude: number;
      longitude: number;
    };
    rating?: string | null;
    address?: string | null;
    krunshScore: number;
    categories?: Array<string | null> | null;
    firstSeenAt?: string | null;
    lastRefreshedAt?: string | null;
    currencyCode: string;
    currencySymbol: string;
    promotionCount: number;
    deliveryTime: number;
  } | null>;
};

export type GetNumberOfAddressesForUserRestaurantsQueryVariables = {};

export type GetNumberOfAddressesForUserRestaurantsQuery = {
  getNumberOfAddressesForUserRestaurants: number;
};

export type GetNumberOfAddressesAfterRemovingUserRestaurantQueryVariables = {
  restaurantIds: Array<string | null>;
};

export type GetNumberOfAddressesAfterRemovingUserRestaurantQuery = {
  getNumberOfAddressesAfterRemovingUserRestaurant: number;
};

export type GetFavoriteListsQueryVariables = {};

export type GetFavoriteListsQuery = {
  getFavoriteLists: Array<{
    __typename: "FavoriteList";
    id: string;
    name: string;
    restaurantCount: number;
  } | null>;
};

export type GetRestaurantsInFavoriteListQueryVariables = {
  favoriteListId: string;
};

export type GetRestaurantsInFavoriteListQuery = {
  getRestaurantsInFavoriteList: Array<{
    __typename: "Restaurant";
    id: string;
    platform: string;
    name: string;
    url?: string | null;
    imageUrl?: string | null;
    position: {
      __typename: "Coordinate";
      latitude: number;
      longitude: number;
    };
    rating?: string | null;
    address?: string | null;
    krunshScore: number;
    categories?: Array<string | null> | null;
    firstSeenAt?: string | null;
    lastRefreshedAt?: string | null;
    currencyCode: string;
    currencySymbol: string;
    promotionCount: number;
    deliveryTime: number;
  } | null>;
};

export type GetRestaurantChartsQueryVariables = {
  id: string;
  length?: HistoryLength | null;
};

export type GetRestaurantChartsQuery = {
  getRestaurantCharts: {
    __typename: "HistoryData";
    krunshScore: Array<{
      __typename: "HistoryEntry";
      date: string;
      value: number;
    } | null>;
    rating: Array<{
      __typename: "HistoryEntry";
      date: string;
      value: number;
    } | null>;
    numberOfRatings: Array<{
      __typename: "HistoryEntry";
      date: string;
      value: number;
    } | null>;
    deliveryTime: Array<{
      __typename: "HistoryEntry";
      date: string;
      value: number;
    } | null>;
    ranking: Array<{
      __typename: "HistoryEntry";
      date: string;
      value: number;
    } | null>;
  };
};

export type GetCurrentSubscriptionQueryVariables = {};

export type GetCurrentSubscriptionQuery = {
  getCurrentSubscription?: {
    __typename: "StripeSubscription";
    productId: string;
    priceId: string;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    cancelAtPeriodEnd: boolean;
  } | null;
};

export type GetEntitlementsQueryVariables = {};

export type GetEntitlementsQuery = {
  getEntitlements: Array<{
    __typename: "Entitlement";
    name: string;
    count: number;
  } | null>;
};

export type ListProductsQueryVariables = {};

export type ListProductsQuery = {
  listProducts: Array<{
    __typename: "StripeProduct";
    name: string;
    description: string;
    marketingFeatures: Array<string | null>;
    prices: Array<{
      __typename: "StripePrice";
      id: string;
      lookupKey?: string | null;
      price?: number | null;
      currency: string;
      interval?: string | null;
      taxBehavior?: string | null;
    } | null>;
    defaultPrice?: string | null;
    isRecurring: boolean;
    isCreditPack: boolean;
    creditPackInfo?: {
      __typename: "CreditPackInfo";
      count: number;
      popular: boolean;
    } | null;
    isMainSubscription: boolean;
  } | null>;
};

export type ListInvoicesQueryVariables = {
  after?: string | null;
};

export type ListInvoicesQuery = {
  listInvoices: {
    __typename: "StripeInvoicesList";
    invoices: Array<{
      __typename: "StripeInvoice";
      id: string;
      amount: number;
      createdAt: string;
      status: InvoiceStatus;
      invoiceUrl?: string | null;
      invoicePdfUrl?: string | null;
    } | null>;
    hasMore?: boolean | null;
  };
};

export type GetRemainingKrunshCreditsQueryVariables = {};

export type GetRemainingKrunshCreditsQuery = {
  getRemainingKrunshCredits: number;
};

export type GetNotificationsQueryVariables = {};

export type GetNotificationsQuery = {
  getNotifications: Array<
    | (
        | {
            __typename: "KrunshScoreNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            oldScore: number;
            newScore: number;
          }
        | {
            __typename: "NewRestaurantsNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            newRestaurantIds: Array<string | null>;
          }
        | {
            __typename: "RatingNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            oldRating: number;
            newRating: number;
          }
        | {
            __typename: "NumberOfRatingsNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            oldNumberOfRatings: number;
            newNumberOfRatings: number;
          }
        | {
            __typename: "RankingNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            oldRanking: number;
            oldRanking7D?: number | null;
            oldRanking28D?: number | null;
            newRanking: number;
            totalCount: number;
          }
        | {
            __typename: "NearbyPromotionCountNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            oldNearbyPromotionCount: number;
            newNearbyPromotionCount: number;
            restaurantIds: Array<string | null>;
          }
        | {
            __typename: "NearbyAveragePriceNotification";
            id: string;
            restaurantId: string;
            type: NotificationType;
            isRead: boolean;
            createdAt: string;
            oldNearbyAveragePrice: number;
            newNearbyAveragePrice: number;
          }
      )
    | null
  >;
};

export type GetGridsQueryVariables = {};

export type GetGridsQuery = {
  getGrids: Array<{
    __typename: "Grid";
    id: string;
    name: string;
    columns: Array<string | null>;
    restaurantCount: number;
    emails?: Array<string | null> | null;
    frequency?: ExportFrequency | null;
  } | null>;
};

export type GetRestaurantsInGridQueryVariables = {
  gridId: string;
  offset?: number | null;
};

export type GetRestaurantsInGridQuery = {
  getRestaurantsInGrid: {
    __typename: "RestaurantsList";
    total: number;
    data: Array<{
      __typename: "RestaurantDetails";
      id: string;
      platform: string;
      name: string;
      phone?: string | null;
      email?: string | null;
      url?: string | null;
      imageUrl?: string | null;
      rating?: string | null;
      ratingCount?: string | null;
      fulfillmentTypes?: Array<string | null> | null;
      address?: string | null;
      krunshScore: number;
      nearbyIndex: number;
      categories?: Array<string | null> | null;
      firstSeenAt?: string | null;
      lastRefreshedAt?: string | null;
      hasPromotion?: boolean | null;
      deliveryTime: number;
      promotionCount: number;
      currencyCode: string;
      currencySymbol: string;
    } | null>;
  };
};

export type OnNewExportSubscriptionVariables = {
  username: string;
};

export type OnNewExportSubscription = {
  onNewExport?: {
    __typename: "Export";
    username: string;
    url: string;
  } | null;
};
